import React, { Component } from 'react';
import { findOne } from '../../actions/permissions';

// let $ = window.jQuery;

export default class MenuLinks extends Component {

    handleClick = (e) => {
        // window.location.hash = this.props.link;
        // let target = e.target.href.split('#');
        // sessionStorage.setItem('lastTab',target[1]);
    };

	componentDidMount() {
		// let lastTab = sessionStorage.getItem('lastTab');
		// if(lastTab)
		// {
		// 	$('#menuTabsLinks').find('a[href="#'+lastTab+'"]').click();
		// }
			
	}

	render () {
		const { userpermissions, permissions } = this.props;

        let grant = true;
        if (permissions) {
            grant = findOne(userpermissions, permissions);
        }

		return (
			// eslint-disable-next-line
			grant ? 
			<li className={this.props.index === 0 ? 'active' : ''}>
                <a href={this.props.link} data-toggle="tab" onClick={this.handleClick}>{this.props.label}</a>
            </li>
            :
            null
		)
	}

}



/** WEBPACK FOOTER **
 ** ./src/components/patient/MenuLinks.js
 **/